










































































import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import PaperItem from '@/main-components/paper-item/PaperItem.vue';
import PaperOption from './PaperOption.vue';
import { CollectionItem } from '@/resource/collection-item/collection-item.model';
import PaperItemLoading from '../paper-item/PaperItemLoading.vue';
import onScrollView from '@/utils/common/on-scroll-view';
import { Collection } from '@/resource/collection/collection.model';
import ModalConfirm from '@/main-components/common/modal/ModalConfirm.vue';
import { DeleteResource, deleteResource } from '@/utils/delete-resource';
import PaperContentEmpty from './PaperContentEmpty.vue';
import QuestionBank from '../question-bank/QuestionBank.vue';
import MainButton from '../common/MainButton.vue';
import ModalVideo from '../common/modal/ModalVideo.vue';
import { getSeenTutorial } from '@/utils/cookie';

@Component({
  components: {
    PaperItem,
    PaperItemLoading,
    PaperOption,
    PaperContentEmpty,
    ModalConfirm,
    ModalVideo,
    QuestionBank,
    MainButton,
  },
})
export default class PaperContent extends Vue {
  @Prop({ required: true })
  paper: Collection;

  @Prop({ default: [] })
  paperItems: CollectionItem[];

  @Prop({ default: false })
  isPaperItemsLoading: boolean;

  @Prop({ default: false })
  isMorePaperItemsLoading: boolean;

  @Prop({ default: false })
  showRearrange: boolean;

  @Prop({ default: 0 })
  totalPaperItems: number;

  @Prop({ default: false })
  isAllPaperItemsLoaded: boolean;

  @Prop({ required: true })
  fetchPaperItems: () => Promise<void>;

  @Prop({ required: true })
  fetchMorePaperItems: () => void;

  subjectiveTitleIndex = 0;
  scrollBottomObserver: IntersectionObserver | null = null;
  openDeleteQuestionModal: any = null;
  openQuestionBankModal: any = null;
  openVideoTutorialModal: any = null;
  toDeleteQuestionId: number | null = null;

  get hasSubjectiveItems() {
    return this.subjectiveTitleIndex + 1 < this.paperItems.length
      ? true
      : false;
  }

  get footerElement() {
    return document.getElementById('main--footer');
  }

  get isShowTutorialQuery(): boolean {
    const tutorial = this.$route.query['tutorial'];
    if (tutorial && typeof tutorial === 'string') {
      return tutorial.toLowerCase() === 'true';
    } else {
      return false;
    }
  }

  mounted() {
    if (this.isShowTutorialQuery || !getSeenTutorial()) {
      this.openVideoTutorialModal && this.openVideoTutorialModal();
    }

    this.observeScrollBottom();
  }

  beforeDestroy() {
    this.unobserveScrollBottom();
  }

  observeScrollBottom() {
    if (this.footerElement) {
      this.scrollBottomObserver = onScrollView(
        this.footerElement,
        this.fetchMorePaperItems,
      );
    }
  }

  unobserveScrollBottom() {
    if (this.scrollBottomObserver && this.footerElement) {
      this.scrollBottomObserver.unobserve(this.footerElement);
    }
  }

  updateSubjectiveTitleIndex(index: number) {
    this.subjectiveTitleIndex = index;
  }

  @Provide('deleteQuestionClicked')
  deleteQuestionClicked(questionId: number) {
    this.toDeleteQuestionId = questionId;
    this.openDeleteQuestionModal && this.openDeleteQuestionModal();
  }

  async onDeleteQuestionSubmit() {
    if (this.toDeleteQuestionId) {
      await deleteResource(
        this.toDeleteQuestionId,
        DeleteResource.COllectionItem,
      );
      this.$toasted.global.mainToast({
        message: 'Question deleted',
      });

      this.toDeleteQuestionId = null;
      await this.fetchPaperItems();
    }
  }

  openDeleteQuestionModalAdd(openModal: any) {
    this.openDeleteQuestionModal = openModal;
  }

  openVideoTutorialModalAdd(openModal: any) {
    this.openVideoTutorialModal = openModal;
  }

  openQuestionBankModalAdd(openModal: any) {
    this.openQuestionBankModal = () => {
      this.$sendMpEvent({ event: this.$mp_value.PaperAddMoreQuestionCLick });
      openModal && openModal();
    };
  }
}
